import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BaseWeekTimetable from '../Tenant-Admin/TimeTable'; // ✅ Default import
import HODHeader from './components/Header';

const HODTimetable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get data from location state or localStorage
  const tenantId = location.state?.tenantId || localStorage.getItem('tenantId');
  const userId = location.state?.userId || localStorage.getItem('userId');
  const organizationId = location.state?.organizationId || localStorage.getItem('organizationId');
  const userRole = location.state?.userRole || localStorage.getItem('userRole');
  const hodDepartmentId = location.state?.hodDepartmentId || null;
  const token = localStorage.getItem('token');

  // Redirect if no tenant or user
  useEffect(() => {
    if (!tenantId || !userId || !token) {
      navigate('/hod/dashboard');
    }
  }, [tenantId, userId, token, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-gray-900">
      <HODHeader />
      <div className="p-4 sm:p-6 lg:p-8">
        <BaseWeekTimetable 
          tenantId={tenantId}
          userId={userId}
          organizationId={organizationId}
          userRole={userRole}
          hodDepartmentId={hodDepartmentId}
          isHODView={true}
        />
      </div>
    </div>
  );
};

export default HODTimetable;